<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
}

html {
  overflow-x: hidden;
}

body {
  width: 100%;
  max-width: 540px;
  margin: 0 auto !important;
  overflow-x: hidden;
}

body,
p,
span {
  margin: 0;
}
</style>
